import React, {useCallback, useMemo, useState} from 'react';

//Styles
import * as S from './TravelImpression.styles';

import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';

import {componentNames, omnitureConfig} from '@stencil/omniture-analytics';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';
import useOmnitureImpressions from '@stencil/omniture-analytics/src/hooks/useOmnitureImpressions';

interface TravelImpressionProps {
  seekTagDetails: any;
  isDesktop?: any;
}
const TravelImpression: React.FC<TravelImpressionProps> = ({
  seekTagDetails = {},
  isDesktop = false,
}) => {
  const [detailsText, expandDetailsText] = useState(seekTagDetails?.seekTagSummary?.slice(0, 500));

  const expandDetailsTextHanlder = useCallback(
    e => {
      e.stopPropagation();
      expandDetailsText(seekTagDetails?.seekTagSummary);
    },
    [seekTagDetails?.seekTagSummary],
  );

  const [omniWatcherRef] = useOmnitureImpressions(
    componentNames.TravelImpression,
    omnitureConfig.pages.DetailsReviews,
    {
      propertyViewHeading: `${DetailsPageComponents.TravelImpression}`,
    },
    true,
  );

  if (isObjectEmpty(seekTagDetails)) return null;
  return (
    <S.OuterWrapper isDesktop={isDesktop} ref={omniWatcherRef}>
      {!isDesktop && <S.Line />}
      <S.Heading>
        <S.IconWrapper src={seekTagDetails?.seekTagIcon} isDesktop={isDesktop} />
        <S.TextWrapper>
          <S.Title isDesktop={isDesktop}>{seekTagDetails?.seekTagsTitle}</S.Title>
          <S.SubTitle isDesktop={isDesktop}>{seekTagDetails?.seekTagsSubtitle}</S.SubTitle>
        </S.TextWrapper>
      </S.Heading>
      <S.TravelImpressionInfo>
        <S.TravelImpressionDetails
          isDesktop={isDesktop}
          dangerouslySetInnerHTML={{__html: detailsText}}
        />
        {seekTagDetails?.seekTagSummary != detailsText && (
          <>
            ...
            <S.ExpandDetails onClick={expandDetailsTextHanlder}>Read More</S.ExpandDetails>
          </>
        )}
      </S.TravelImpressionInfo>
    </S.OuterWrapper>
  );
};

export default TravelImpression;
